import { PaymentMethodType } from 'app/util/constants';
import styled from 'styled-components';

export const MenuWrapper = styled.div<{ backgroundColor: string }>`
  ${({ backgroundColor }) => `background-color: ${backgroundColor}`}
`;

export const showPaymentMethodItem = (selectedPaymentMethodName: string, paymentMethodName: string) =>
  selectedPaymentMethodName === '' || selectedPaymentMethodName === paymentMethodName;

export const changePaymentMethodsToLastPosition = (methods: PaymentMethodType[], init: number) =>
  methods.push(methods.splice(init, 1)[0]);
